import { FC } from 'react';
import { useFetchProfileQuery } from 'rtkQuery/sharespro/queries/profile';
import CommunityPrivateChannelCardsRowContainer from './CommunityPrivateChannelCardsRowContainer';
import PrivateChannelNoAccessContainer from './PrivateChannelNoAccessContainer';

const CommunityPrivateChannelContainer: FC = () => {
  const { data } = useFetchProfileQuery();

  if (!data) return null;

  if (data.isPrivateChannelAllowed) {
    return <CommunityPrivateChannelCardsRowContainer />;
  } else {
    return <PrivateChannelNoAccessContainer/>;
  }
};

export default CommunityPrivateChannelContainer;
